import {Button, HeadingElement} from 'components';
import React from 'react';
import {useNavigate} from "react-router-dom";
import './aboutHeroInfo.scss';

const HeroInfo = () => {
    const navigate = useNavigate();
    return (
        <div className="about-hero-info" id={'mission'}>
            <div className="about-hero-info_wrapper max">
                <div className="about-hero-info_wrapper_left">
                    <HeadingElement/>
                    <h1>Small Business Association of Jamaica Mission</h1>
                    <p>The mission of the SBAJ is to support the Jamaican economy by developing the small business
                        sector through:</p>
                    {/*<Button text={"Join Us Today"} type={'primary'} onclick={() => navigate('/registration/')}/>*/}

                </div>
                <div className="about-hero-info_wrapper_right">
                    <h1>Overview</h1>
                    <p>The Vision of the SBAJ is to become an organization of national and regional economic
                        importance, political influence and the main voice of the small business sector in
                        Jamaica.</p>

                    <p>Ut suspendisse augue consectetur sodales urna. Nisl, fusce facilisi auctor ut dolor a,
                        commodo. Dictum penatibus elit quam mollis sed viverra vitae tristique. Tincidunt
                        commodo vitae id amet, eget vitae nec. Cras interdum donec amet ut tincidunt proin
                        viverra. Eu mauris pellentesque consequat convallis dolor tortor.</p>
                </div>

            </div>
        </div>
    );
};

export default HeroInfo;
